<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      class="InsuranceDetail"
      :style="{
        width: '100%',
        height: height
      }"
      :get-container="getContainer"
    >
      <ld-header
        :title="$t('Q102','保险说明')"
        @click-left="isShow = false"
      />
      <div class="check-box">
        <h3 v-show="value.besmList && value.besmList.length > 0">
          【<span class="font-bold font16">{{ $t('Q103','保额说明') }}</span>】
        </h3>
        <p
          v-for="(besm, i) in value.besmList"
          v-show="besm"
          :key="i"
          style="padding: 5px 0 10px 10px;"
        >
          {{ i + 1 }}、{{ besm }}
        </p>

        <h3 v-show="value.xssm">
          【<span class="font-bold font16">{{ $t('Q113','销售说明') }}</span>】
        </h3>
        <pre class="pad8 pre-wrap">
          {{ value.xssm }}
        </pre>

        <span
          v-show="value.bxtkList && value.bxtkList.length > 0"
          class="pad8"
        >{{ $t('Q117','点击下载') }}</span>
        <a
          v-for="(bxtk, i) in value.bxtkList"
          :key="i"
          href="javascript:(0);"
          v-show="bxtk"
          @click="download(bxtk)"
          class="pad8 main-color"
        >
          <span>{{ $t('Q118','保险条款') }}</span>{{ i+1 }}
        </a>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Toast } from 'vant'

export default {
  name: 'InsuranceDetail',
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      isShow: false
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    height: {
      type: String,
      default: '100%'
    },
    visibility: {
      type: Boolean,
      default: false
    },
    element:{
      type: String,
      default: ''
    }
  },
  methods: {
    download (url) {
      this.$LdDownload({ sendScene: 3, url })
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
  },
  watch: {
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>

<style lang="less">
.InsuranceDetail {
  h3 {
    margin: 5px 0;
  }

  .pad8 {
    padding: 8px;
  }

  .check-box {
    min-height: 50vh;
    height: auto;
    padding-bottom: 30px;
    padding: 10px;
  }
}
</style>